import React, { useState, useEffect, useRef, useCallback, createRef } from 'react';
import { useRouteMatch, Link } from 'react-router-dom';
import { Carousel } from './Carousel';
// import { list } from './mock';
import classnames from 'classnames';
import { StarBackground } from './StarBackground';
import style from './Home.module.css';
import headBg from '../../assets/images/head_bg.svg';
import headBorder from '../../assets/images/head_border.svg';
import { getScreens } from '../../actions';
import { connect } from 'react-redux';
import { raf } from '../../utils/raf';
import defaultLogo from '../../assets/images/logo_1.png'

// todo: 给border 左右箭头加上光效
// todo: 左右箭头 加浮动效果

export function Head({ logo }: { logo: string }) {
  return (
    <div>
      <img src={headBg} style={{ position: 'absolute', top: 0, left: 0, right: 0, margin: 'auto', transform: 'translateX(-5px)' }} />
      <img src={headBorder} style={{ position: 'absolute', top: 28, left: 0, right: 0, margin: 'auto', transform: 'translateX(6px)' }} />
      <div
        style={{
          width: 235,
          height: 70,
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          margin: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img src={logo || defaultLogo} style={{ maxWidth: 180, maxHeight: 45 }} />
      </div>
    </div>
  );
}

const containerEl = createRef<HTMLDivElement>();

function _Home({ screens, id, dispatch, setting }: { screens: Cockpit.Screen[]; id: string; dispatch: Cockpit.dispatch; setting: any }) {
  useEffect(() => {
    dispatch(getScreens());
  }, []);

  // scale: [width, height]
  const [scale, setScale] = useState([0, 0]);

  useEffect(() => {
    const setLayout = raf(() => {
      if (containerEl && containerEl.current) {
        const el = containerEl.current;
        setScale([el.offsetWidth, el.offsetHeight]);
      }
    });
    window.addEventListener('resize', setLayout);
    setLayout()
    return () => {
      window.removeEventListener('resize', setLayout);
    };
  }, []);

  return (
    <React.Fragment>
      <div className={style.bg}></div>
      <div className={style.container} ref={containerEl} style={{ paddingTop: 100, paddingBottom: 80 }}>
        <StarBackground width={scale[0]} height={scale[1]} />
        <span className={style.shape_left}></span>
        <span className={style.shape_bottom}></span>
        <span className={style.shape_right}></span>
        <span className={classnames(style.border_line, style['border_line--top'])}></span>
        <span className={classnames(style.border_line, style['border_line--bottom'])}></span>
        <span className={style.corner_topleft}></span>
        <span className={style.corner_bottomright}></span>

        <Head logo={setting.homeLogo} />
        <Link to={`/${id}/setting`}>
          <span className={style.button_admin}>后台管理</span>
        </Link>

        <div style={{ position: 'relative', height: '100%', width: '100%', left: 0, top: 0 }}>
          <Carousel width={scale[0]} height={scale[1] - 180} />
        </div>
      </div>
    </React.Fragment>
  );
}

export const Home = connect<any, any, any, Cockpit.Store>(store => ({
  screens: store.screens.filter(o => o.show),
  id: store.id,
  setting: store.setting
}))(_Home);
